/** Base URL for prematch assets (jerseys, flag, overlays). Used by mock getters and future API. */
export const PREMATCH_ASSETS_BASE_URL =
  import.meta.env.VITE_API_BASE_URL_DEV || 'https://widget.demo.suzumuchi.dk';
export const PREMATCH_JERSEYS_BASE_URL = `${PREMATCH_ASSETS_BASE_URL}/icons/assets/pms/jerseys`;
